import { defineMessages } from 'react-intl';

export const sideNavFooterMessages = defineMessages({
  profile: {
    defaultMessage: 'Profile',
    id: 'mQagQzAEhg',
    description:
      'Sidebar user-account menu entry that opens account/profile settings (workspace switcher IA)',
  },
  defaultUserName: {
    defaultMessage: 'User',
    id: 'chugB4gGEg',
    description: 'Fallback display name when the user has no first or last name',
  },
  getStartedFaq: {
    defaultMessage: 'Get started & FAQ',
    id: '+Ty5wOmNSy',
    description: 'Sidebar link to the German get-started and FAQ Notion page',
  },
  referAndEarn: {
    defaultMessage: 'Refer to Win',
    id: 'nPM/ELtEuv',
    description: 'Sidebar CTA for Evidence users to open the referral modal',
  },
  getMobileApp: {
    defaultMessage: 'Get Heidi for Mobile',
    id: '44BmfnDgiI',
    description: 'User account menu item to open the mobile app download modal',
  },
  organization: {
    defaultMessage: 'Organisation',
    id: 'kvE7oJADXH',
    description: 'User account menu item for global admins to open organisation settings',
  },
  team: {
    defaultMessage: 'Team',
    id: 'E+rKMBu3Qp',
    description: 'User account menu item to open team settings',
  },
  newLayout: {
    defaultMessage: 'New Scribe layout',
    id: 'fZ4AFhz8aS',
    description: 'User account menu label for the Session Page V2 layout switch',
  },
  newLayoutToggle: {
    defaultMessage: 'Enable new layout',
    id: 'igT8BlOo2G',
    description:
      'Accessible label for the Session Page V2 layout switch in the user menu',
  },
  settings: {
    defaultMessage: 'Settings',
    id: 'pmMNetjEl1',
    description: 'User account menu item to open settings',
  },
  logOut: {
    defaultMessage: 'Log out',
    id: 'ExIfxbXouK',
    description: 'User account menu item to sign out',
  },
  cpdMenuItemAriaLabel: {
    defaultMessage:
      '{cpdTerm}, {count, plural, one {# source referenced} other {# sources referenced}}',
    id: 'N4QlpDyAV7',
    description:
      'Accessible label for the CPD menu item combining the regional CPD term and source count',
  },
  templates: {
    defaultMessage: 'Templates',
    id: 'gkviaNhPFw',
    description:
      'Sidebar footer rail entry linking to the My Templates page (sidebar IA rejig)',
  },
});
